import { type FC } from "react";
import { type PostContentBlocksType } from "~/utils/postUtils";
import Image from "next/image";
type SocialComponentProps = {
  block: PostContentBlocksType;
};

const SocialComponent: FC<SocialComponentProps> = ({ block }) => {
  return (
    <ul className={`wp-block-social-links aligncenter has-huge-icon-size`}>
      {block.innerBlocks.map((social, index) => {
        return (
          <li
            key={index}
            className={`wp-social-link wp-social-link-${social?.attrs?.service}  wp-block-social-link`}
          >
            <a
              className="wp-block-social-link-anchor"
              target="_blank"
              rel="noopener"
              href={social?.attrs?.url}
            >
              <Image
                src={`/icon/${social?.attrs.service}-ico.svg`}
                width="24"
                height="24"
                alt={social.attrs.service}
              />
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default SocialComponent;
